var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BCrumbs',{attrs:{"get_bcrumbs":_vm.get_bcrumbs}}),_c('v-container',{staticClass:"pa-0 mt-10",staticStyle:{"width":"1080px"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('ImageComponent',{attrs:{"get_product_page":_vm.get_product_page}}),_c('ProductDetails',{attrs:{"get_product_page":_vm.get_product_page}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }